import React, {useState} from 'react';
import numberFormat from "../../../helpers/numberFormat";
import {Form, Row, Tab, Table, Tabs} from "react-bootstrap";
import {showCount} from "../../../helpers/showCount";
import moment from "moment/moment";
import _, {difference} from 'lodash'
import {Link} from "react-router-dom";
import dataTable from "../../../components/dataTable";
import ServiceQuickEditModal from "./serviceQuickEditModal";

const isKrs3300 = (row) => row.type === 'SRV' && Math.floor(row.krsTotal) === 3300

const YanaKayarRender = ({data, onReload}) => {
  const [showKrs, setShowKrs] = useState(false)
  const [showLinks, setShowLinks] = useState(false)
  const [editRow, setEditRow] = useState(null)

  const openEdit = (row) => setEditRow({
    siteId: row.bookingId,
    itemNumber: row.ticketNumber,
    description: row.route
  })

  const renderStandartBody = (array,source, total = true, stringGoogle) =>{
    return <tbody style={{color:"black"}}>
    {array.map((u, index) => {
      const style={width: 850,color:"black"}

      const renderFirstCol = () =>{
        let string = (! u.airline && !u.ticketNumber) ? 'Без номера' :`${u?.airline? u?.airline : ''} ${u.ticketNumber} ${u.refund ? ' B' :''}`
        const summ = Intl.NumberFormat("en-US").format(u.baseSumm)
        if(u.source === '1C payment' || u.source === 'Cash payment') {
          if(u.currency === 'USD'){
            string = `${u.ticketNumber} - $${summ} конвертация по курсу ${numberFormat(u.exchangeRate)}`
          }else{
            string = `${u.ticketNumber} - ${summ} KZT`
          }
        }
        return <td>
          {u.bookingId && showLinks?  <Link to={u.baseLink+u.bookingId} target={'_blank'}>{string}</Link> : string}
          {isKrs3300(u) && u.bookingId && <i
            className="fa fa-pencil text-primary ml-2 text-black"
            style={{cursor: 'pointer'}}
            onClick={() => openEdit(u)}
          />}
        </td>
      }
      return (
        <tr key={index} style={isKrs3300(u) ? {backgroundColor:'rgba(255,0,0,0.22)'} : undefined}>
          {stringGoogle && <tr>{u.index}</tr>}
          {renderFirstCol()}
          <td>{moment(u.issueDate).format('DD.MM.YYYY')}</td>
          <td>{u.pax}</td>
          <td>{u.route}</td>
          <td>{numberFormat(u.total)}</td>
          {source && <td>{u.source}</td>}
        </tr>
      );
    })
    }
    {total && <tr>
      <td colSpan={4}>
        <b>Итого</b>
      </td>
      <td>
        <b>
          {numberFormat(
            array
              .map(u => u.total)
              .reduce((a, b) => a + b, 0)
          )}
        </b>
      </td>
    </tr>}
    </tbody>
  }

  const renderSumm = ( ) =>{
    let summ = 0
    data.tableData.forEach(row=>{
      summ += row.data[6] === '' ? -row.data[7] : row.data[6]
    })
    return summ
  }

  return (
    <>
      <Form.Label className={'d-flex align-items-center gap-2 mb-2'}>
        <input
          defaultChecked={showLinks}
          onChange={()=>setShowLinks(!showLinks)}
          type={"checkbox"}
        />{" "}
        Показать ссылки
      </Form.Label>
      {data.yanaCompanies && `Компании: ${data.yanaCompanies.join(" / ")}`}
    <Row>
      <Tabs defaultActiveKey="correct">
        <Tab
          eventKey="correct"
          title={`Правильные (${data.correct.length})`}
        >
          <Table striped hover>
            {renderHeader()}
            {renderStandartBody(data.correct)}
          </Table>
        </Tab>
        <Tab
          eventKey="noYana"
          title={`Есть в Kayar но нет в Yana(Акт) (${showCount(data.yanaMissing)})`}
        >
          <Table striped hover>
            {renderHeader()}
            {renderStandartBody(data.yanaMissing)}
          </Table>
        </Tab>
        <Tab
          eventKey="noKayar"
          title={`Есть в Yana(Акт) но нет в Kayar (${showCount(data.kayarMissing)})`}
        >
          <Table striped hover>
            {renderHeader()}
            {renderStandartBody(data.kayarMissing)}
          </Table>
        </Tab>
        {data.kayarDuplicates && data.kayarDuplicates.length>0 && <Tab
          eventKey="kayarDuplicates"
          title={`Дублируются в Kayar (${showCount(data.kayarDuplicates)})`}
        >
          <Table striped hover>
            {renderHeader()}
            {data.kayarDuplicates.map((array,i)=>{
              return <React.Fragment key={i}>
                {renderStandartBody(array,false,false)}
              </React.Fragment>
            })}
          </Table>
        </Tab>}
        {data.yanaDuplicates && data.yanaDuplicates.length>0 && <Tab
          eventKey="yanaDuplicates"
          title={`Дублируются в Yana (${showCount(data.yanaDuplicates)})`}
        >
          <Table striped hover>
            {renderHeader(false,true)}
            {data.yanaDuplicates.map((array,i)=>{
              return <React.Fragment key={i}>
                {renderStandartBody(array,false,false, true)}
              </React.Fragment>
            })}
          </Table>
        </Tab>}

        <Tab
          eventKey="diff"
          title={`Отличаются (${showCount(data.diff)})`}
        >
          <Table striped bordered hover>
            <thead>
            <tr>
              <td rowSpan={2}>Номер</td>
              <td rowSpan={2}>Пассажир</td>
              <td rowSpan={2}>Маршрут</td>
              <td rowSpan={2}>Выписан Yana</td>
              <td rowSpan={2}>Выписан Kayar</td>
              <td className={'text-center'} colSpan={3}>
                Итог
              </td>
            </tr>
            <tr className={'text-center'} >
              <td>Yana</td>
              <td>Kayar</td>
              <td>Разница</td>
            </tr>
            </thead>
            <tbody>
            {data.diff.map((u, index) => {
              return (
                <tr key={index} style={isKrs3300(u) ? {backgroundColor:'rgba(255,0,0,0.22)'} : undefined}>
                  <td>
                    {u.airline} {u.ticketNumber} {u.refund && ' B'}
                    {isKrs3300(u) && u.bookingId && <i
                      className="fa fa-pencil text-primary ml-2"
                      style={{cursor: 'pointer'}}
                      onClick={() => openEdit(u)}
                    />}
                  </td>
                  <td>{u.pax}</td>
                  <td>{u.route}</td>
                  {u.issueDate === u.yanaIssueDate ?
                  <td colSpan={2} className={'text-center'}>{moment(u.issueDate).format('DD.MM.YYYY')}</td>:
                    <>
                      <td>{moment(u.yanaIssueDate || u.issueDate).format('DD.MM.YYYY')}</td>
                      <td>{moment(u.issueDate).format('DD.MM.YYYY')}</td>
                    </>}


                  {renderValue(u.total)}
                </tr>
              );
            })}
            </tbody>
          </Table>
        </Tab>
        <Tab
          eventKey="unrecognized"
          title={`Нераспознаные (${showCount(data.unrecognized)})`}
        >
          <Table striped hover>
            {renderHeader(true)}
            {renderStandartBody(data.unrecognized,true)}
          </Table>
        </Tab>
        {data.tableData && <Tab
          eventKey="toGoogle"
          title={`Для вставки`}
        >
          <Form.Label className={'d-flex align-items-center gap-2 mt-2'}>
            <input
              defaultChecked={showKrs}
              onChange={()=>setShowKrs(!showKrs)}
              type={"checkbox"}
            />{" "}
            Показать колонку "Крс"
          </Form.Label>
          {(showKrs || showLinks )&& <div className={'text-danger text-center'}>Копирование вместе с крс/ссылками недоступно!Выключите показ крс/ссылок</div>}
          <Table bordered className={(showKrs || showLinks) ? 'user-select-none' : ''}>
            {showKrs &&
              <thead>
              <tr>
                <td>Выписан</td>
                <td>Начало</td>
                <td>Номер</td>
                <td>Пассажир</td>
                <td>Маршрут</td>
                <td>Крс</td>
                <td>Итого</td>
              </tr>
              </thead>}
            <tbody>
            {data.tableData.map((row,index)=>{
              return <tr key={index} style={{color:'black', backgroundColor: Math.floor(row.data[5]) === 3300 && !!row.data[12] ? 'rgba(255,0,0,0.22)': 'white'}}>
                {row.data.map((c,i)=>{
                  return <td key={i}
                             className={i===0 ?'text-end':''}
                             style={i===5 ? {display: showKrs ? 'block' : 'none'}:{}}
                  >{(i===2 && row.link?.bookingId && showLinks) ?
                    <Link to={row.link.baseLink+row.link.bookingId} target={'_blank'}>{c}</Link> :
                    c }</td>
                })}
              </tr>
            })}
            </tbody>
          </Table>
          Итого : {numberFormat(renderSumm())}
        </Tab>}
        {data.payments && <Tab
          eventKey="payments"
          title={`Платежи (${data.payments.length})`}
        >
          <Table striped bordered hover>
            <thead>
            <tr>
              <td>Дата</td>
              <td>Оплатил</td>
              <td>Сумма</td>
              <td>Банк</td>
            </tr>
            </thead>
            <tbody>
            {data.payments.map((u, index) => {
              return (
                <tr key={index}>
                  <td>
                    {u.issueDate}
                  </td>
                  <td>{u.comment}</td>
                  <td>{numberFormat(u.total)}</td>
                  <td>{u.bank}</td>
                </tr>
              );
            })}
            </tbody>
          </Table>
        </Tab>}

      </Tabs>
    </Row>
      {editRow && <ServiceQuickEditModal
        row={editRow}
        onHide={() => setEditRow(null)}
        onSaved={onReload}
      />}
    </>
  );
};

export default YanaKayarRender;



const renderHeader = (source, stringGoogle) => {
  return <thead>
  <tr>
    {stringGoogle && <td>Строка</td>}
    <td>Номер</td>
    <td>Выписан</td>
    <td>Пассажир</td>
    <td>Маршрут</td>
    <td>Итого</td>
    {source && <td>Источник</td>}
  </tr>
  </thead>
}

const renderValue = (value) =>{
  if(typeof value !== 'object'){
    return <td className={'text-center'} colSpan={3}>{numberFormat(value)}</td>
  }else{
    return <>
      <td className={'text-center'} >{numberFormat(value.yana)}</td>
      <td className={'text-center'} >{numberFormat(value.kayar)}</td>
      <td className={'text-center'} >{numberFormat(Math.abs(value.yana-value.kayar))}</td>
    </>
  }
}

